module.exports = __webpack_public_path__ + "static/media/moon-transparent.06d60f79.png";